var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 7,
  viewBox: "0 0 12 7",
  width: 12,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1 1 4.60667 4.83333c.0516.05174.11291.09279.1804.12079.0675.02801.13986.04243.21293.04243.07308 0 .14543-.01442.21293-.04243.06749-.028.1288-.06905.1804-.12079l4.60667-4.83333",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
})));
export default SvgChevronDown;